import { render, staticRenderFns } from "./Valora.vue?vue&type=template&id=0a62ad53&scoped=true&"
import script from "./Valora.vue?vue&type=script&lang=js&"
export * from "./Valora.vue?vue&type=script&lang=js&"
import style0 from "./Valora.vue?vue&type=style&index=0&id=0a62ad53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a62ad53",
  null
  
)

export default component.exports